import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileDto } from '@ideapa/common-dto';

import { ApiClientConfig } from './api-client-config';

@Injectable()
export class FileApiClient {
  baseUrl = this.config.apiEndpoint + '/file';

  upload(list: FileList) {
    const files = Array.from(list);
    const fd = new FormData();
    files.forEach((file) => fd.append('files', file));
    return this.http.post<FileDto[]>(this.baseUrl + '/upload', fd);
  }

  download(attachment: FileDto) {
    return this.http.post(this.baseUrl + '/download', attachment, {
      responseType: 'arraybuffer',
    });
  }

  constructor(private http: HttpClient, private config: ApiClientConfig) {}
}
